import React from "react";
import UserContext from "../userContext";
import Calendar from "../Layout/Components/Elements/Calendar";

export default function Dashboard() {
    const userContext = React.useContext(UserContext)

    if (userContext.loading) {
        return (
            <div className="dashboard">
                <div className="dashboard__loading">
                    <div className="spinner" />
                    <p>Chargement de vos interventions...</p>
                </div>
            </div>
        )
    }

    return (
        <div className="dashboard">
            <section className="dashboard__calendar">
                <Calendar
                    data={userContext.data?.interventions}
                    backs={userContext.backs}
                    id={userContext.user?.id}
                    scope="month"
                />
            </section>
        </div>
    )
}
